import { t } from "i18next";

import {
  ISoccerMatchSubstituteEvent,
  SoccerPlayerPosition,
} from "../../../types";
import { IPlayers } from "./formationHelper";

export const POSITION_ORDER = [
  SoccerPlayerPosition.GOALKEEPER,
  SoccerPlayerPosition.DEFENDER,
  SoccerPlayerPosition.WING_BACK,
  SoccerPlayerPosition.DEFENSIVE_MIDFIELDER,
  SoccerPlayerPosition.MIDFIELDER,
  SoccerPlayerPosition.ATTACKING_MIDFIELDER,
  SoccerPlayerPosition.STRIKER,
  SoccerPlayerPosition.SUBSTITUTE,
];

export const POSITION_LABELS = {
  [SoccerPlayerPosition.GOALKEEPER]: t("positions.Goalkeeper"),
  [SoccerPlayerPosition.DEFENDER]: t("positions.Defenders"),
  [SoccerPlayerPosition.WING_BACK]: t("positions.WingBacks"),
  [SoccerPlayerPosition.DEFENSIVE_MIDFIELDER]: t(
    "positions.DefensiveMidfielders"
  ),
  [SoccerPlayerPosition.MIDFIELDER]: t("positions.Midfielders"),
  [SoccerPlayerPosition.ATTACKING_MIDFIELDER]: t(
    "positions.AttackingMidfielders"
  ),
  [SoccerPlayerPosition.STRIKER]: t("positions.Forwards"),
  [SoccerPlayerPosition.SUBSTITUTE]: t("positions.Substitutes"),
};

const getPlayerById = (players: IPlayers[], id: string): IPlayers | undefined =>
  players.find((player) => player.id === id);

export const getDisplayPlayerInfo = ({
  activePlayer,
  substituteEvent,
  allPlayers,
}: {
  activePlayer: IPlayers;
  substituteEvent?: ISoccerMatchSubstituteEvent;
  allPlayers: IPlayers[];
}) => {
  if (!substituteEvent) {
    return {
      name: activePlayer.name,
      jerseyNumber: activePlayer.jerseyNumber,
      id: activePlayer.id,
    };
  }

  const isPlayerSubstitutedOff =
    substituteEvent.playerOffId === activePlayer.id;

  if (isPlayerSubstitutedOff) {
    const replacementPlayer = getPlayerById(
      allPlayers,
      substituteEvent.playerOnId
    );
    return {
      name: substituteEvent.playerOnName,
      jerseyNumber:
        replacementPlayer?.jerseyNumber || activePlayer.jerseyNumber,
      id: substituteEvent.playerOnId,
    };
  } else if (!isPlayerSubstitutedOff) {
    const replacementPlayer = getPlayerById(
      allPlayers,
      substituteEvent.playerOffId
    );
    return {
      name: substituteEvent.playerOffName,
      jerseyNumber:
        replacementPlayer?.jerseyNumber || activePlayer.jerseyNumber,
      id: substituteEvent.playerOffId,
    };
  }

  return {
    name: activePlayer.name,
    jerseyNumber: activePlayer.jerseyNumber,
    id: activePlayer.id,
  };
};

export const getSubstituteDisplayInfo = ({
  player,
  substituteEvent,
}: {
  player: IPlayers;
  substituteEvent?: ISoccerMatchSubstituteEvent;
}) => {
  if (!substituteEvent?.playerOffId) return null;

  const isPlayerSubstitutedOn = substituteEvent.playerOnId === player.id;
  const displayName = isPlayerSubstitutedOn
    ? player.name
    : substituteEvent.playerOffName;

  return {
    time: substituteEvent.timeMin,
    playerName: displayName,
  };
};
